import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
} from '@mui/material';

export function CTASection() {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        mt: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: 'center',
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            background: (theme) =>
              `linear-gradient(145deg, ${theme.palette.primary.light}, ${theme.palette.primary.main} 40%, ${theme.palette.secondary.dark})`,
            boxShadow: [
              '0 24px 60px rgba(99,102,241,0.5)',
              '0 10px 24px rgba(0,0,0,0.3)',
              'inset 0 3px 0 rgba(255,255,255,0.28)',
              'inset 0 -3px 0 rgba(0,0,0,0.2)',
            ].join(', '),
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.3), transparent 35%)',
              filter: 'blur(24px)',
              opacity: 0.7,
            }}
          />
          <Typography
            variant="h3"
            component="h2"
            sx={{
              mb: 3,
              fontWeight: 800,
              color: 'white',
              position: 'relative',
              zIndex: 1,
            }}
          >
            Ready to Transform Your Learning?
          </Typography>
          <Typography
            variant="h6"
            component="p"
            sx={{
              mb: 4,
              color: 'rgba(255,255,255,0.9)',
              maxWidth: '600px',
              mx: 'auto',
              position: 'relative',
              zIndex: 1,
            }}
          >
            Join thousands of students who are already mastering their subjects with BrainLoop's innovative Study Loops.
          </Typography>
          <Button
            component={Link}
            to="/signup"
            variant="contained"
            size="large"
            sx={{
              position: 'relative',
              zIndex: 1,
              px: 3.5,
              py: 1.6,
              fontWeight: 700,
              fontSize: 16,
              bgcolor: 'white',
              color: 'primary.main',
              boxShadow: '0 16px 50px rgba(0,0,0,0.28)',
              '&:hover': {
                bgcolor: 'grey.100',
              },
            }}
          >
            Start Free Trial
          </Button>
          <Typography
            variant="caption"
            sx={{
              position: 'relative',
              zIndex: 1,
              color: 'rgba(255,255,255,0.6)',
              display: 'block',
              mt: 2,
            }}
          >
            Free plan included · No credit card required · Cancel anytime
          </Typography>
        </Box>
      </Container>
    </Box>
  );
} 